export default "__VITE_ASSET__CKdZGgWd__"